import React from 'react'
import moment from 'moment'
import { IDevice } from '@getgreenline/homi-shared'
import { GrTime } from '../../../../../utilities/helpers'
import { Table } from 'antd-v4'
import { shiftsTableColumns } from './ShiftsTableColumns'
import { ShiftModels } from '@getgreenline/shifts'

interface Props {
  shifts: ShiftModels.IBaseShift[]
  devices: IDevice[]
  onDetailsClick: (shift: ShiftModels.IBaseShift) => void
  onSalesClick: (shift: ShiftModels.IBaseShift) => void
  onFloatCountClick: (shift: ShiftModels.IBaseShift, device?: IDevice) => void
  isLoading?: boolean
}

interface ShiftTableRecord {
  key: number
  location: JSX.Element
  device: JSX.Element
  shiftStart: JSX.Element
  shiftEnd: JSX.Element
  totalTime: JSX.Element
  status: JSX.Element
  details: JSX.Element
  sales: JSX.Element
  floatCount: JSX.Element
}

export const ShiftsTable: React.FC<Props> = ({
  shifts,
  devices,
  onDetailsClick,
  onSalesClick,
  onFloatCountClick,
  isLoading,
}: Props) => {
  const tableDataSource: ShiftTableRecord[] = shifts.map((shift) => {
    let formattedStartEndTimeDiff = ''

    if (shift.endDate) {
      const minBetweenShiftStartEnd = moment(shift.endDate).diff(shift.createDate, 'minutes')
      formattedStartEndTimeDiff = GrTime.convertMinsToHrsMins(minBetweenShiftStartEnd)
    }
    return {
      key: shift.id,

      location: <div>{shift.locationName}</div>,
      device: <div>{shift.deviceName}</div>,
      shiftStart: <div>{moment(shift.createDate).format('MMM DD hh:mm a')}</div>,
      shiftEnd: <div>{shift.endDate ? moment(shift.endDate).format('MMM DD hh:mm a') : '-'}</div>,
      totalTime: <div>{formattedStartEndTimeDiff ? formattedStartEndTimeDiff : '-'}</div>,

      status: (
        <div>
          {shift.endDate ? 'Completed' : <span className='badge badge-warning'>In progress</span>}
        </div>
      ),
      details: (
        <div>
          <a onClick={() => onDetailsClick(shift)}>View receipt</a>
        </div>
      ),
      sales: (
        <div>
          <a
            onClick={() => {
              onSalesClick(shift)
            }}
          >
            View sales
          </a>
        </div>
      ),
      floatCount: (
        <div>
          {shift.endDate && (
            <a
              onClick={() => {
                const clickedDevice = devices.find((d) => d.deviceId === shift.deviceName)
                onFloatCountClick(shift, clickedDevice)
              }}
            >
              {shift.cashCount === null ? 'Start' : 'View'}
            </a>
          )}
        </div>
      ),
    }
  })

  return (
    <Table<ShiftTableRecord>
      dataSource={tableDataSource}
      rowKey={(shift) => shift.key}
      className='no-background-table show-horizontal-scrollbar'
      rowClassName={() => 'background-white'}
      columns={shiftsTableColumns}
      pagination={false}
      scroll={{ x: 'max-content' }}
      loading={isLoading}
    />
  )
}
